import { useMemo } from 'react';
import { useCrossReferenceStore } from 'store/useCrossReferenceStore';
import type { CrossReferenceCellKey } from './types';
import { computeMatchColor, type CrossReferenceMatchColor } from './utils/matchStatus';

const useCrossReferenceMatch = (
  cellKey: CrossReferenceCellKey,
  hostValue: number | null | undefined
): CrossReferenceMatchColor => {
  const state = useCrossReferenceStore(store => store.states[cellKey]);
  return useMemo(() => computeMatchColor(hostValue, state), [hostValue, state]);
};

export default useCrossReferenceMatch;
